import { PersonBus } from './PersonBus';
import { BaseBus } from './BaseBus';
import { CommonFunctions } from '../static/common-functions';
import { EmployHistoryBus } from './EmployHistory';
import { DateFunctions } from '../static/date-functions';

export class EmployeeBus extends BaseBus {
    constructor(busObj: BaseBus = null) {
        super(busObj);
        this.person = new PersonBus();
        if (busObj != null) {

        } else {

        }
    }
    public setFromForm(busObj: any) {
        this.person = new PersonBus();
        this.employeeId = busObj.employeeId;
        this.personId = busObj.personId;
        this.person.personId = busObj.personId;
        this.person.co = busObj.co;
        this.person.firstName = busObj.firstName;
        this.person.lastName = busObj.lastName;
        this.person.middleName = busObj.middleName;
        this.person.legalName = busObj.legalName;
        this.person.address1 = busObj.address1;
        this.person.address2 = busObj.address2;
        this.person.city = busObj.city;
        this.person.state = busObj.state;
        this.person.zip = busObj.zip;
        this.person.birthday = new Date(busObj.birthday);
        this.person.contactEmail = busObj.contactEmail;
        this.person.emailPersonal = busObj.emailPersonal;
        this.person.timekey = busObj.timekey;
        this.person.empNo = busObj.empNo;
        this.ssn = busObj.ssn;
        this.person.companyId = busObj.companyId;
        this.person.companyBranchId = busObj.companyBranchId;
        this.person.baseUnionId = busObj.baseUnionId;
        this.person.jobRoleId = busObj.jobRoleId;
        this.commissionProgram = busObj.commissionProgram;
        this.person.poapprLimit = busObj.poapprLimit ?? 0;
        this.person.isActive = busObj.isActive;
        this.person.hasMobile = busObj.hasMobile;
        this.person.jobTitle = busObj.jobTitle;
        this.person.jobTitlesId = busObj.jobTitlesId;
        this.person.mainNumber = busObj.mainNumber;
        this.person.cellNumber = busObj.cellNumber;
        this.person.personalPhone = busObj.personalPhone;
        this.person.skillRating = busObj.skillRating;
        this.person.trade = busObj.trade;
        this.person.costCenter = busObj.costCenter;
        this.person.dlnbr = busObj.dlnbr;
        this.person.dlexpire = new Date(busObj.dlexpire);
        this.person.dlstate = busObj.dlstate;
        this.person.hasCreditCard = busObj.hasCreditCard;
        this.person.creditCard = busObj.creditCard;
        this.person.epanbr = busObj.epanbr;
        this.person.i9verified = busObj.i9verified;
        this.person.requireClockInOut = busObj.requireClockInOut;
        this.person.managerId = busObj.managerId;
        this.person.departmentId = busObj.departmentId;
        this.person.secJobRoleId = busObj.secJobRoleId;
        this.person.termDt = new Date(busObj.termDt);
        this.person.onStockReplenishment =busObj.onStockReplenishment;
        this.hasSalary = busObj.hasSalary;
        this.hourlyRate = busObj.hourlyRate;
        this.commissionCustomers = CommonFunctions.getCommaDelimitedStringFromArray(busObj.commissionCustomers);
        this.overheadRate = busObj.overheadRate;
        this.overheadCost = busObj.overheadCost;
        this.overScale = busObj.overScale;
        this.overheadPercent = busObj.overheadPercent;
        this.commissionPercent = busObj.commissionPercent;
        this.specialOverheadRate = busObj.specialOverheadRate;
        this.person.covidVaccinationDate = busObj.covidVaccinationDate;
        this.person.covidVaccinationNotVaccinated = busObj.covidVaccinationNotVaccinated;
        this.person.covidBoosterDate = busObj.covidBoosterDate;
        this.person.covidBoosterNotVaccinated = busObj.covidBoosterNotVaccinated;
        this.person.covidSecondVaccinationDate = busObj.covidSecondVaccinationDate;
        this.person.covidVaccinationBrand = busObj.covidVaccinationBrand;
        this.person.covidSecondVaccinationBrand = busObj.covidSecondVaccinationBrand;
        this.person.covidBoosterVaccinationBrand = busObj.covidBoosterVaccinationBrand;
        this.person.sCpin = busObj.sCpin;
        this.person.creditMemoApprLimit = busObj.creditMemoApprLimit;
        this.hasShiftDifferential = busObj.hasShiftDifferential;
        this.shiftDifferential = busObj.shiftDifferential;
        this.shiftDifferentialOT = busObj.shiftDifferentialOT;
        this.payrollCompanyCodeId = busObj.payrollCompanyCodeId
    }
    setBeforeSave() {
        if (this.person) {
            if (this.person.birthday) { this.person.birthday = DateFunctions.getDateTimeWithUTCOffset(this.person.birthday); }
            if (this.person.dlexpire) { this.person.dlexpire = DateFunctions.getDateTimeWithUTCOffset(this.person.dlexpire); }
            if (this.person.termDt) { this.person.termDt = DateFunctions.getDateTimeWithUTCOffset(this.person.termDt); }
            if (this.person.covidVaccinationDate) { this.person.covidVaccinationDate = DateFunctions.getDateTimeWithUTCOffset(this.person.covidVaccinationDate); }
            if (this.person.covidBoosterDate) { this.person.covidBoosterDate = DateFunctions.getDateTimeWithUTCOffset(this.person.covidBoosterDate); }
            if (this.person.covidSecondVaccinationDate) { this.person.covidSecondVaccinationDate = DateFunctions.getDateTimeWithUTCOffset(this.person.covidSecondVaccinationDate); }
        }

    }
    employeeId: any;
    companyId: any;
    personId: any;
    hourlyRate: number;
    overheadRate: number;
    overheadCost: number;
    overheadPercent: number;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    ssn: string;
    commissionPercent: number;
    hasSalary: boolean;
    overScale: number;
    payrollCompanyCodeId: string;
    specialOverheadRate: number;
    person: PersonBus;
    ssnClear: string;
    commissionCustomers: string;
    commissionProgram: string;
    hasShiftDifferential: boolean;
    shiftDifferential: number;
    shiftDifferentialOT: number;
    CID(): any {
        super.CID();
        return this.employeeId;
    }

}
